module.exports = __webpack_public_path__ + "static/media/bridge-high.7457eb10.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/trueBridge/bridge-high.png
// module id = 110
// module chunks = 0